import React, { useState, useMemo, useEffect } from 'react';
import classNames from 'classnames';
import { Popover as AntdPopover, PopoverProps as AntdPopoverProps } from 'antd';
import type { PopoverSemanticClassNames } from "antd/es/popover";
import { CloseIcon } from 'components/Icons';
import cn from './styles.module.scss';

export interface PopoverProps extends AntdPopoverProps {
  closable?: boolean,
  title?: React.ReactNode
}

export const Popover = ({
  content,
  title: propsTitle,
  open,
  onOpenChange,
  children,
  closable,
  ...props
}: PopoverProps) => {
  const [visible, setVisible] = useState(open ?? false);

  useEffect(() => {
    if (visible !== open) {
      setVisible(Boolean(open));
    }
  }, [open]);

  const handleVisibleChange = (newVisible: boolean) => {
    if (closable && !newVisible) {
      return;
    }

    setVisible(newVisible);

    if (onOpenChange) {
      onOpenChange(newVisible);
    }
  };

  const title = useMemo(() => {
    if (!closable) {
      return propsTitle;
    }

    return (
      <div className={cn.title}>
        <div>{propsTitle}</div>
        <CloseIcon
          onClick={() => setVisible(false)}
        />
      </div>
    );
  }, [propsTitle, closable]);

  return (
    <AntdPopover
      content={content}
      title={title}
      onOpenChange={handleVisibleChange}
      open={visible}
      {...props}
      classNames={{
        ...props.classNames,
        content: classNames(cn.content, (props.classNames as PopoverSemanticClassNames)?.content),
      }}
    >
      {children}
    </AntdPopover>
  );
};
